/**
 * DevExtreme (esm/ui/scheduler/constants.js)
 * Version: 23.1.5
 * Build date: Wed Aug 30 2023
 *
 * Copyright (c) 2012 - 2023 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */
export var LIST_ITEM_DATA_KEY = "dxListItemData";
export var LIST_ITEM_CLASS = "dx-list-item";
export var APPOINTMENT_SETTINGS_KEY = "dxAppointmentSettings";
export var HORIZONTAL_GROUP_ORIENTATION = "horizontal";
export var VIEWS = {
    DAY: "day",
    WEEK: "week",
    WORK_WEEK: "workWeek",
    MONTH: "month",
    TIMELINE_DAY: "timelineDay",
    TIMELINE_WEEK: "timelineWeek",
    TIMELINE_WORK_WEEK: "timelineWorkWeek",
    TIMELINE_MONTH: "timelineMonth",
    AGENDA: "agenda"
};
